import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { Router } from './routes/route';
// import { useUrfPostEvents, useUrfReceiveEvents } from "./hooks/urfEvents";
// useUrfReceiveEvents

function App() {
  // useUrfReceiveEvents();
  return (
    <div className="rims-app">
      <RouterProvider router={Router} />
    </div>
  );
}

export default App;
